

export const Texts_DE = {
    LABELS: {
        supportIdeas: "Ideen unterstützen",
        promoteInnovation: "Innovationen fördern",
        supportGrowth: "Wachstum begleiten",
        createValue: "Werte schaffen",
    }
}

export default Texts_DE;
